import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'sendgrid',
  version: '1.2.0',
  properties: [
    {
      key: 'credential',
      label: 'SendGrid API Credential',
      type: 'credential',
      required: true,
      credentialTypes: [{ name: 'sendgrid_api', required: true }],
      description: 'SendGrid API key credential',
    },
    {
      key: 'from',
      label: 'From',
      type: 'string',
      required: true,
      placeholder: 'sender@example.com',
      description: 'Sender email address (must be verified in SendGrid)',
    },
    {
      key: 'fromName',
      label: 'From Name',
      type: 'string',
      default: '',
      placeholder: 'Sender Name',
      description: 'Display name for the sender (optional)',
    },
    {
      key: 'to',
      label: 'To',
      type: 'string',
      required: true,
      placeholder: 'recipient@example.com',
      description: 'Recipient email address(es), comma-separated',
    },
    {
      key: 'cc',
      label: 'CC',
      type: 'string',
      default: '',
      placeholder: 'cc@example.com',
      description: 'CC email address(es), comma-separated',
    },
    {
      key: 'bcc',
      label: 'BCC',
      type: 'string',
      default: '',
      placeholder: 'bcc@example.com',
      description: 'BCC email address(es), comma-separated',
    },
    {
      key: 'replyTo',
      label: 'Reply To',
      type: 'string',
      default: '',
      placeholder: 'reply@example.com',
      description: 'Reply-to email address (optional)',
    },
    {
      key: 'subject',
      label: 'Subject',
      type: 'string',
      required: true,
      placeholder: 'Email subject',
      description: 'Email subject line',
    },
    {
      key: 'contentType',
      label: 'Content Type',
      type: 'options',
      required: true,
      default: 'text',
      options: [
        { label: 'Plain Text', value: 'text' },
        { label: 'HTML', value: 'html' },
        { label: 'Both', value: 'both' },
      ],
      description: 'Type of email content to send',
    },
    {
      key: 'textContent',
      label: 'Text Content',
      type: 'text',
      default: '',
      placeholder: 'Plain text email body',
      description: 'Plain text version of the email',
      typeOptions: {
        rows: 6,
      },
      displayOptions: {
        show: {
          contentType: ['text', 'both'],
        },
      },
    },
    {
      key: 'htmlContent',
      label: 'HTML Content',
      type: 'text',
      default: '',
      placeholder: '<p>HTML email body</p>',
      description: 'HTML version of the email',
      typeOptions: {
        rows: 10,
      },
      displayOptions: {
        show: {
          contentType: ['html', 'both'],
        },
      },
    },
    {
      key: 'attachments',
      label: 'Attachments',
      type: 'string',
      placeholder: '{{ $node["NodeName"].binary }}',
      description:
        'Path to attachment data in input. Expected format: array of {filename, content (base64), contentType}',
    },
  ],
};

export default schema;
